import { render } from "./heroSlider.vue?vue&type=template&id=23112a20&scoped=true"
import script from "./heroSlider.vue?vue&type=script&lang=js"
export * from "./heroSlider.vue?vue&type=script&lang=js"

import "./heroSlider.vue?vue&type=style&index=0&id=23112a20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23112a20"]])

export default __exports__